import React, { useContext } from "react";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { StorageContext } from "./contexts/StorageContext";
import pagesConfig from "./config/pagesConfig";
import pages from "./pages/index";
import { Colors, fonts, Spacing } from "./config";
import styled from "styled-components";
import { Footer, Header, Menu } from "./features";
import { CustomText } from "./components";
import meshBg from "./assets/images/mesh-bg.png";

const PageContainer = styled.div(({ theme }) => ({
  display: "flex",
  width: "100%",
  height: '100vh',
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  overflowY: "auto",
  overflowX: "hidden",
  padding: Spacing(3),
  backgroundImage: `url(${meshBg})`,
  backgroundAttachment: "fixed",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  paddingBlock: "clamp(12px, 3vw, 60px)",
  paddingInline: "clamp(12px, 6vw, 150px)",
  gao: '60px',
}));

const PageContainerLanding = styled.div(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  backgroundColor: "#8D9B9C",
  paddingBlock: "clamp(12px, 3vw, 60px)",
  paddingInline: "clamp(12px, 6vw, 150px)",
}));

interface IUserProps {
  Home: () => Element;
}

function App() {
  const location = useLocation();

  const { isLogged, cancelToken, dataAp, setDataAp } =
    useContext<any>(StorageContext);
  const [menuHeight, setHeight] = React.useState<any>(null);
  const [menu, setMenu] = React.useState<any>(false);

  React.useLayoutEffect(() => {
    const mh = document.getElementById("header-menu")?.offsetHeight;

    setHeight(mh);
  }, [menuHeight]);

  React.useEffect(() => {
    cancelToken.cancel();
  }, [location.pathname, cancelToken]);

  return !isLogged ? (
    <PageContainer>

        <Header dataAp={dataAp} openMenu={() => setMenu(true)} />

        <Routes>
          {pagesConfig.logged.map((item: any, index?: any) => {
            if (item.pages) {
              return item.pages.map((page: any, index?: any) => {
                const Component = pages[page.name as keyof IUserProps];
                return (
                  <Route
                    key={page.navigationId}
                    path={page.path}
                    element={<Component />}
                  />
                );
              });
            }
            return null;
          })}
        </Routes>
        <CustomText
          fontSize={1.5}
          fontFamily={fonts.medium}
          textColor={Colors.whiteBackground}
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBlock: Spacing(3),
          }}
        >
          {process.env.REACT_APP_ENV + " v"}
          {process.env.REACT_APP_VERSION}
        </CustomText>


    </PageContainer>
  ) : (
    <PageContainerLanding>
      <Routes>
        {pagesConfig.notLogged.map((item?: any, index?: any) => {
          const Component = pages[item.name as keyof IUserProps];
          return (
            <Route
              key={item.path + index}
              path={item.path}
              element={<Component />}
            />
          );
        })}
      </Routes>
    </PageContainerLanding>
  );
}

export default App;
